import React, { useEffect } from "react";
import _ from "lodash";

import ActivePlayerReading from "../components/ActivePlayerReading";
import NonActiveReading from "../components/NonActiveReading";

const CHPTEvaluating = ({
  isActivePlayer,
  roomId,
  currentPlayerCard,
  currentPlayer,
  prompt,
  played_cards,setWinnerSelectedCard,buzzer_sound,default_audio_effect
}) => {
  useEffect(() => {
    if (
      isActivePlayer &&
      !_.isEmpty(default_audio_effect) 
   
    ) {
      buzzer_sound();
    }
  }, [buzzer_sound, isActivePlayer, default_audio_effect]);
  return (
    <>
      {isActivePlayer ? (
        <ActivePlayerReading
          roomId={roomId}
          prompt={prompt}
          currentPlayerCard={currentPlayerCard}
          played_cards={played_cards}
          setWinnerSelectedCard={setWinnerSelectedCard}
        />
      ) : (
        <NonActiveReading currentPlayerCard={currentPlayerCard} />
      )}
    </>
  );
};

export default CHPTEvaluating;
